import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { EmpresaProvider } from './contexts/EmpresaContext';
import { ParticipanteProvider } from './contexts/ParticipanteContext';
import { ContasBancariasProvider } from './contexts/ContasBancariasContext';
import { BackofficeAuthProvider } from './contexts/BackofficeAuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { GrupoEmpresaProvider } from './contexts/GrupoEmpresaContext';
import MobileBlocker from './components/layout/MobileBlocker';
import EmpresaAuthBridge from './components/auth/EmpresaAuthBridge';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <EmpresaProvider>
        <GrupoEmpresaProvider>
          <ParticipanteProvider>
            <ContasBancariasProvider>
              <BackofficeAuthProvider>
                <AdminAuthProvider>
                  <EmpresaAuthBridge />
                  <MobileBlocker />
                  <AppRoutes />
                </AdminAuthProvider>
              </BackofficeAuthProvider>
            </ContasBancariasProvider>
          </ParticipanteProvider>
        </GrupoEmpresaProvider>
      </EmpresaProvider>
    </BrowserRouter>
  );
}

export default App;